export default __webpack_public_path__ + "assets/images/a49fcb90a7a1553871155351b2859d0f.svg";